import React, { useMemo } from 'react';
import Select from 'react-select';
import CustomSelection from '../../../../../../customControl/CustomSelection';
import CustomTimePicker from '../../../../../../customControl/CustomTimePicker';

const FlightInclusion = ({
    disabled,
    isFlightIncluded,
    flightvisible,
    flightopen,
    handleFlight,
    // From & To
    flightfrom,
    flightfromid,
    handleFlightFromchange,
    fromflightdisable,
    flightto,
    flighttoid,
    handleFlightToChange,
    toflightdisable,
    // Flight Card
    formvalue,
    onChange,
    airlinelist,
    airlineid,
    handleAirlineChange,
    flightnolist,
    flightno,
    handleFlightNoChange,
    arrivalTime,
    departureTime,
    handleonchangeofTime,
    airlineclasslist,
    classid,
    handleclasschange,
    supplierlist,
    supplierid,
    handlesupplierchange
}) => {
    const selectedFlightFrom = useMemo(() => flightfrom?.find(item => item.value === flightfromid) || null, [flightfrom, flightfromid]);
    const selectedFlightTo = useMemo(() => flightto?.find(item => item.value === flighttoid) || null, [flightto, flighttoid]);
    const selectedAirline = useMemo(() => airlinelist?.find(item => item.value === airlineid) || null, [airlinelist, airlineid]);
    const selectedFlightNo = useMemo(() => flightnolist?.find(item => item.value === flightno) || null, [flightnolist, flightno]);
    const selectedClass = useMemo(() => airlineclasslist?.find(item => item.value === classid) || null, [airlineclasslist, classid]);
    const selectedSupplier = useMemo(() => supplierlist?.find(item => item.value === supplierid) || null, [supplierlist, supplierid]);

    if (!flightvisible) return null;

    return (
        <>
            <div className="col-lg-12 col-sm-12">
                <div className="row">
                    <div className="col-lg-2 col-md-12 mb-1">
                        <label className="col-form-label">Add Flight</label>
                    </div>
                    <div className="col-lg-1 col-md-2 mb-1">
                        <label className="col-form-label">From</label>
                    </div>
                    <div className="col-lg-3 mb-1 col-md-4">
                        <CustomSelection
                            datalist={flightfrom}
                            fieldid={flightfromid}
                            SelectionChange={handleFlightFromchange}
                            isdisable={disabled || !isFlightIncluded}
                            isactivedisable={fromflightdisable}
                            issearchable
                        />
                    </div>
                    <div className="col-lg-1 col-md-2 mb-1">
                        <label className="col-form-label">To</label>
                    </div>
                    <div className="col-lg-3 mb-1 col-md-4">
                        <CustomSelection
                            datalist={flightto}
                            fieldid={flighttoid}
                            SelectionChange={handleFlightToChange}
                            isdisable={disabled || !isFlightIncluded}
                            isactivedisable={toflightdisable}
                            issearchable
                        />
                    </div>
                    <div className="col-lg-2 mb-1 col-md-12">
                        <button
                            disabled={!isFlightIncluded}
                            type="button"
                            className="btn btn-primary mx-1"
                            onClick={handleFlight}
                            id="btnAdd"
                        >
                            <i className={`fa fa-plus ${flightopen ? "fa-minus" : "fa-plus"}`} aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>

            {flightopen && (
                <div className="col-lg-12 col-sm-12 mt-3 mb-2 py-2 form_border ms-2">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 mb-1">
                            <label className="col-form-label">Flight Details</label>
                        </div>
                        <div className="col-lg-12 col-sm-12">
                            <div className="row">
                                <div className="col-lg-1 col-md-2 mb-1">
                                    <label className="col-form-label">From</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-3">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={flightfrom}
                                        value={selectedFlightFrom}
                                        isDisabled
                                        isSearchable
                                    />
                                </div>
                                <div className="col-lg-1 col-md-2 mb-1">
                                    <label className="col-form-label">To</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-3">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={flightto}
                                        value={selectedFlightTo}
                                        isDisabled
                                        isSearchable
                                    />
                                </div>
                                <div className="col-lg-1 col-md-3 mb-1">
                                    <label className="col-form-label">Duration</label>
                                </div>
                                <div className="col-lg-3 mb-1 col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="Duration"
                                        value={formvalue?.Duration || ''}
                                        onChange={onChange}
                                        disabled
                                        placeholder="Duration"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Select Airline Name</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={airlinelist}
                                        value={selectedAirline}
                                        onChange={handleAirlineChange}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Flight No</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={flightnolist}
                                        value={selectedFlightNo}
                                        onChange={handleFlightNoChange}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Arrival Time</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <CustomTimePicker
                                        classid="ArrivalTimeD"
                                        filedvalue={arrivalTime}
                                        isDisable
                                        handleOnChange={(e) => handleonchangeofTime("ArrivalTimeD", e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Departure Time</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <CustomTimePicker
                                        classid="DepartureTimeD"
                                        filedvalue={departureTime}
                                        isDisable
                                        handleOnChange={(e) => handleonchangeofTime("DepartureTimeD", e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Select Class</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={airlineclasslist}
                                        value={selectedClass}
                                        onChange={handleclasschange}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Select Supplier</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <Select
                                        className="dropdown select_dropdown"
                                        options={supplierlist}
                                        value={selectedSupplier}
                                        onChange={handlesupplierchange}
                                        isDisabled={disabled}
                                        isSearchable
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-sm-6">
                            <div className="row">
                                <div className="col-lg-4 col-md-12 mb-1">
                                    <label className="col-form-label">Price</label>
                                </div>
                                <div className="col-lg-8 mb-1 col-md-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="FlightPrice"
                                        value={formvalue?.FlightPrice || ''}
                                        onChange={onChange}
                                        disabled={disabled}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default React.memo(FlightInclusion);

